export const dashboardData = [
  {
    id: 1,
    jobName: "Calculation Engine",
    runs: [
      { RunId: 1, Result: "Success", Timestamp: "2025-01-28 10:00:00" },
      { RunId: 2, Result: "Fail", Timestamp: "2025-01-28 10:05:00" },
      { RunId: 3, Result: "Success", Timestamp: "2025-01-28 10:10:00" },
      { RunId: 4, Result: "Fail", Timestamp: "2025-01-28 10:15:00" },
      { RunId: 5, Result: "Success", Timestamp: "2025-01-28 10:20:00" },
    ],
  },
  {
    id: 2,
    jobName: "SFTP to Blob",
    runs: [
      { RunId: 1, Result: "Success", Timestamp: "2025-01-28 10:00:00" },
      { RunId: 2, Result: "Fail", Timestamp: "2025-01-28 10:05:00" },
      { RunId: 3, Result: "Success", Timestamp: "2025-01-28 10:10:00" },
      { RunId: 4, Result: "Fail", Timestamp: "2025-01-28 10:15:00" },
      { RunId: 5, Result: "Success", Timestamp: "2025-01-28 10:20:00" },
    ],
  },
  {
    id: 3,
    jobName: "Pipeline C",
    runs: [
      { RunId: 1, Result: "Success", Timestamp: "2025-01-28 10:00:00" },
      { RunId: 2, Result: "Fail", Timestamp: "2025-01-28 10:05:00" },
      { RunId: 3, Result: "Success", Timestamp: "2025-01-28 10:10:00" },
      { RunId: 4, Result: "Fail", Timestamp: "2025-01-28 10:15:00" },
      { RunId: 5, Result: "Success", Timestamp: "2025-01-28 10:20:00" },
    ],
  },
  {
    id: 4,
    jobName: "Pipeline D",
    runs: [
      { RunId: 1, Result: "Success", Timestamp: "2025-01-28 10:00:00" },
      { RunId: 2, Result: "Fail", Timestamp: "2025-01-28 10:05:00" },
      { RunId: 3, Result: "Success", Timestamp: "2025-01-28 10:10:00" },
      { RunId: 4, Result: "Fail", Timestamp: "2025-01-28 10:15:00" },
      { RunId: 5, Result: "Success", Timestamp: "2025-01-28 10:20:00" },
    ],
  },
]

export const years = ["2016", "2017", "2018","2019", "2020", "2021","2022", "2023", "2024", "2025", "2026"];

export const loadProfiles = [
  "LP1",
  "LP2",
  "LP3",
  "LP4",
  "LP5",
  "LP6",
  "LP7",
  "LP8",
  "LP9",
  "LP10",
  "LP11",
  "LP25",
  "LP27", 
  "LP29"
];

export const AlertsTimeFilter = [
  "Today",
  "This Week",
  "This Month",
  "This Year"
]

export enum TaskName {
  CalculateUsage = 0,
  RecalculatingEstimates = 1,
  EstimatingUsage = 2,
  Withdrawal = 3,
  Passthrough = 4,
  ParseXmltoDB = 5,
  DayAheadParseCsv = 6,
  EstimatingUsageParallel = 7
}